export default {
  role: {
    RoleCode: 'Role Code',
    RoleName: 'Role Name',
    OnlineRegister: 'Online Register',
    Custom: 'Custom',
    SystemRetention: 'System Retention',
    ChooseSystem: 'Choose System',
    PleaseChooseSystem: 'Please Choose System',
    RoleInformation: 'Role Information',
    RoleId: 'Role Id',
    AuthorityInformation: 'Authority Information',
    ModelName: 'Model Name'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/en/base/role.js